<template>
    <div class="jumbotron header" :style="{background: `url(${$parent.corporation.theme_marketplace_header}) no-repeat center center`}">
        <div class="row">
            <div class="col-12 text-center">
                <h3 class="new-header-title" v-if="!saludFamiliar">{{t('Your next learning experience')}}</h3>
                <div v-else style="margin-top: 8rem!important"></div>
            </div>
            <div class="col-12 text-center">
                <div v-if="corporationInfo.show_home_search_event === 1" class="search-area mx-auto position-relative"
                    :style="corporationStyles">
                    <input @keyup.enter="doSearch(keyword)" type="text"
                           v-model="keyword" class="form-control"
                           v-bind:placeholder="t('Search for an event')">

                    <b-button @click="doSearch(keyword)" type="button"
                            class="btn btn-light">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </b-button>
                </div>
                <!--ul class="list-inline header-buttons">
                    <li class="list-inline-item">
                        <a id="online" href="#"
                           @click.prevent.stop="changeMode('Online')" class="btn btn-default blue">
                            {{t('Online')}} <i class="bg-iconOnline"></i>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a id="onsite" href="#"
                           @click.prevent.stop="changeMode('Onsite')" class="btn btn-default blue">
                            {{t('Onsite')}} <i class="bg-iconOnsite"></i>
                        </a>
                    </li>
                </ul -->
            </div>
        </div>
    </div>
</template>

<script>
import {  mapState, } from "vuex";
export default {
    name: "JumbotronHeader",
    data() {
        return {
            keyword: null,
            saludFamiliar: false
        }
    },
    computed: {
        ...mapState(['corporationInfo']),
        corporationStyles() {
            let styles = {};
            const filtersColor = _.get(this.$parent, 'corporation.color_filters', null);

            if (filtersColor) {
                styles.backgroundColor = filtersColor;
            }

            return styles;
        }
    },
    props: {
        value: {
            type: Object
        }
    },
    methods: {
        doSearch(keyword) {
            this.assignFilter({keyword: keyword});
        },
        changeMode(newMode) {
            this.assignFilter({mode: newMode});
        },
        assignFilter(params) {
            const filters = this.value ? _.cloneDeep(this.value) : {};
            Object.assign(filters, params);
            this.$emit('input', params);
        }
    },
    created() {
        console.log(this.$parent.corporation);
        this.$translate.setLang('spanish');
    },
    mounted(){
		if (window.location.href.includes("saludfamiliar")) {
            this.saludFamiliar = true
        }
    },
}
</script>

<style scoped>
    h3.new-header-title {
        font-size: 40px;
        letter-spacing: -0.13px;
        line-height: 50px;
        text-align: center;
        text-shadow: 0 2px 2px rgba(0,0,0,0.5);
        margin-top: 100px;
    }

    .search-area {
        height: 60px;
        width: 573px;
        border-radius: 4px;
        box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    }

    .search-area input {
        width: calc(100% - 60px);
        position: absolute;
        height: 60px;
        background-color: transparent;
        border: none;
        font-size: 20px;
        font-style: italic;
        line-height: 26px;
        padding-left: 20px;
    }

    .search-area .btn {
        background-color: transparent;
        border: none;
        font-size: 25px !important;
        position: absolute;
        right: 15px;
        top: 5px;
    }


    @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
        .search-area {
            width: 280px;
        }
    }
</style>
